import React from 'react';
import styled from 'styled-components';

import { IconButton } from '@mui/material';
import { DeleteOutlineOutlined } from '@mui/icons-material';
import { useTheme } from '../../../../../../../../../styles/theme';
import { Expression } from '@common/Expression';
import { BasicInput } from '@common/Expression/Basic';
import { HTTPRequestParameter } from '../../../tool.types';

const Container = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 3fr 7fr 42px;
`;

const Action = styled.div`
  display: flex;
  align-items: center;

  svg {
    font-size: 2ch;
  }
`;

interface Props {
  parameter: HTTPRequestParameter;
  toolArgumentOptions: object;
  updateField: (field: 'name' | 'value', value: string) => void;
  deleteField: () => void;
}

export const RequestParameterField: React.FC<Props> = ({
  parameter,
  toolArgumentOptions,
  updateField,
  deleteField,
}) => {
  const theme = useTheme();

  const { name, value } = parameter;

  return (
    <Container>
      <BasicInput
        key={`name`}
        keyProp={`name`}
        value={name}
        setValue={(value) => updateField('name', value)}
        placeholder='param'
        minRows={1}
        maxRows={1}
        maxWidth='160px'
        wrapping={false}
      />
      <Expression
        key={`value`}
        keyProp={`value`}
        value={value}
        wrapping={false}
        title={'Value'}
        description='The value of the parameter.'
        setValue={(value) => updateField('value', value)}
        options={toolArgumentOptions}
        placeholder='value'
        minRows={1}
        maxRows={1}
      />
      <Action>
        <IconButton
          sx={{ border: `1px solid ${theme.line.light}`, height: '42px', width: '42px' }}
          onClick={deleteField}
        >
          <DeleteOutlineOutlined sx={{ fontSize: '1.4ch !important', color: theme.text.subtext }} />
        </IconButton>
      </Action>
    </Container>
  );
};
